export const toKebabCase = (str: string): string => {
  if (!str) return '';

  return str
    .split(/(?=[A-Z])|_|\s+/g)
    .map((word) => word.toLowerCase())
    .join('-');
};

export function toCamelCase(string: string): string {
  if (!string) {
    return '';
  }

  return string
    .split(/_|-|\s+/g)
    .map((word, idx) => {
      if (idx == 0) {
        return word.toLowerCase();
      }
      return word.replace(word[0], word[0].toUpperCase());
    })
    .join('');
}

export const toSnakeCase = (str): string => {
  if (!str) return '';

  return str
    .split(/(?=[A-Z])|-|\s+/g)
    .map((word) => word.toLowerCase())
    .join('_');
};

export function toTitle(string: string): string {
  if (!string) {
    return '';
  }

  return string
    .split(/(?=[A-Z])|-|__|_|\s+/)
    .map((word) => word.replace(word[0], word[0].toUpperCase()).trim())
    .join(' ');
}

export function capitalize(string: string): string {
  if (!string) {
    return '';
  }

  return string.replace(string[0], string[0].toUpperCase()).trim();
}

export function deepClone<T>(obj: T): T {
  // TODO: update this method to actually clone
  // return JSON.parse(JSON.stringify(obj));
  if (!obj) return obj;

  if (obj.constructor === Array) return cloneArray(obj) as T;

  if (typeof obj === 'string' || typeof obj === 'function') return obj;

  const clone = {};

  Object.keys(obj).forEach((key) => {
    const el = obj[key];

    if (!el) clone[key] = el;
    else if (el.constructor === Array) clone[key] = cloneArray(el);
    else if (el.constructor === Object) clone[key] = deepClone(el);
    else clone[key] = el;
  });

  return clone as T;
}

export function cloneArray<T>(array): T[] {
  return array.map((el) => {
    return deepClone(el);
  });
}

export function singularize(str: string) {
  const endings = {
    ves: 'fe',
    ies: 'y',
    i: 'us',
    zes: 'ze',
    ses: 's',
    es: 'e',
    s: ''
  };

  return str.replace(new RegExp(`(${Object.keys(endings).join('|')})$`), (r) => endings[r]);
}
